<script lang="ts">
import { defineComponent,reactive, ref, onMounted,computed,watchEffect,watch,defineProps } from 'vue';
import { MinusCircleIcon,PlusCircleIcon,InformationCircleIcon } from '@heroicons/vue/24/solid';
import { HoverCard, HoverCardContent, HoverCardTrigger, } from '@/components/ui/hover-card'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator, } from '@/components/ui/breadcrumb'
import { Tabs, TabsContent, TabsList, TabsTrigger, } from '@/components/ui/tabs'
import { NumberField, NumberFieldContent, NumberFieldDecrement, NumberFieldIncrement, NumberFieldInput, } from '@/components/ui/number-field'
import { PopoverClose } from 'radix-vue';
import { QuestionMarkCircledIcon } from '@radix-icons/vue'
import Treeselect from 'vue3-treeselect'
import 'vue3-treeselect/dist/vue3-treeselect.css'
import { VueDraggableNext } from 'vue-draggable-next'
import  useDebounce  from '@/components/useDebounce';
import { Switch } from '@/components/ui/switch'
import { Popover, PopoverContent, PopoverTrigger, } from '@/components/ui/popover'
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger, } from '@/components/ui/sheet'
import { FormControl, FormDescription, FormField, FormItem, FormLabel, } from '@/components/ui/form' 
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue, } from '@/components/ui/select'
import { useRoute } from 'vue-router';
import OnOff from '@/components/OnOff.vue';
import WebsiteDisplay from '@/components/WebsiteDisplay.vue';
import Header from '@/components/Header.vue';
import { Progress } from '@/components/ui/progress';
import axios from 'axios'; // Ensure axios is installed
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger, } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import ColorInput from 'vue-color-input'

interface Config {
	[category: string]: {
		[key: string]: any; // Allows any key-value pairs in each category
	};
}
interface Asset {
	id: number;
	name: string;
	key: string;
	phone: string;
	website: string;
}


interface Features {
	ssoDomains?: string;
}

interface NewFeaturesData {
	ssoDomains?: string[];
}

interface Group {
	label: string;
	includeChildren: boolean;
	groupId: number;
}
interface Saml {
	domain: string;
	entity_id: string;
	newEntity: string;
	email_attribute: string;
}
interface ProfileField {
	label: string;
	type: string;
	width: number;
	required: number;
}
interface MediaField {
	label: string;
	type: string;
	width: number;
	required: number;
	related_id: number;
}
interface Node {
	id: string; // Change to `number` if `id` is a number
	name: string;
}

interface NormalizedNode {
	id: string; // Change to `number` if `id` is a number
	label: string;
}

interface Val {
	id: string; // Change to number if `id` is a number
	hasChildGroups?: boolean; // Optional if not always present
}


export default defineComponent({
	name: 'UploadLauncher',
	components: {
		MinusCircleIcon,
		PlusCircleIcon,
		InformationCircleIcon,
		Breadcrumb,
		BreadcrumbItem,
		BreadcrumbLink,
		BreadcrumbList,
		BreadcrumbPage,
		BreadcrumbSeparator,
		ColorInput,
		Tabs,
		TabsContent,
		TabsList,
		TabsTrigger,
		OnOff,
		draggable: VueDraggableNext,
		Treeselect,
		WebsiteDisplay,
		Header,
		QuestionMarkCircledIcon,
		Popover,
		PopoverContent,
		PopoverClose,
		PopoverTrigger,
		FormControl,
		FormDescription,
		FormField,
		FormItem,
		FormLabel,
		Switch,
		Sheet,
		SheetContent,
		SheetDescription,
		SheetHeader,
		SheetTitle,
		SheetTrigger,
		Select,
		SelectContent,
		SelectGroup,
		SelectItem,
		SelectLabel,
		SelectTrigger,
		SelectValue,
		Label,
		Input,
		Progress,
		Card,
		CardContent,
		CardDescription,
		CardFooter,
		CardHeader,
		CardTitle,
		Button,
		NumberField,
		NumberFieldContent,
		NumberFieldDecrement,
		NumberFieldIncrement,
		NumberFieldInput,
		Dialog,
		DialogContent,
		DialogDescription,
		DialogFooter,
		DialogHeader,
		DialogTitle,
		DialogTrigger,
		HoverCard,
		HoverCardContent,
		HoverCardTrigger,
	},
	props: {
		page: String,
		appId: String,
		vhostId: String,
	},


	setup(props) {
		const appId = ref("");
		const vhost = ref("");

		const currentPage = computed(() => props.page ?? "up-defaults");

		type LocationQueryValue = string | string[] | null | undefined;
		const registrationField = reactive({
			field: '',
			type: '',
			label: '',
			key: '',
			width: 1,
			helpText:'',
			required:0,
		});

		const uploadField = reactive({
			field: '',
			type: '',
			label: '',
			helpText: '',
			key: '',
			width: 1,
			related_id: 0,
			required: 0,
		});
		const predefinedProfileFields = reactive([
			'email', 'user', 'firstname', 'lastname', 'password', 'address1', 'address2', 'city', 'state', 'country', 
			'postal', 'gender', 'birthdate', 'cellphone', 'phone', 'website', 'occupation', 'school', 'language', 
			'newsletter', 'Geo Location'
		]);

		const predefinedMediaFields = reactive({
			title: 'A title for your file',
			message: 'A description about the file',
			tags: 'Keywords that describe the title',
			parentid: 'The ID of the file you want to associate it with',
			'Geo Location': 'Will generate a map requesting the user to provide a location',
			replaceMedia: 'Allow you to upload a new version of an existing file, the media id for the file to replace must be provided',
			'Channel Chooser': 'A drop down of available channels and their children',
			'Group Chooser': 'A drop down of available groups and their children',
		});

		const predefinedWidths = reactive(['Half', 'Full']);
		const selectedProfileWidth = ref('Full');
		const fieldTypes = reactive(['Text', 'Email', 'Password', 'Number', 'File', 'Checkbox', 'Text Area','Media Lookup']);
		const profileFields = ref<ProfileField[]>([
		]);
		const mediaFields = ref<MediaField[]>([]);
		const groupTree = ref<any[]>([]); 
		const channelTree = ref<any[]>([]);
		const route = useRoute();
		const features = ref<Features>({});
		const newFeaturesData = ref<NewFeaturesData>({ ssoDomains: [] });
		const saml = ref<Saml>({ domain: '', entity_id: '', email_attribute: '',newEntity:''});
		const emptyGroup = reactive<Group>({ groupId: 0, includeChildren: false, label: ''});
		const additionalDomains = ref<any[]>([]);
		const applicationInfo = ref<any>(null);
		const assetList = ref<Asset[]>([]);
		const config = ref<Config>({ global: { assets_headerImage: null } });
		const currentStep = ref(1);
		const totalSteps =8;
		const step =8;
		const data = ref<any>(null);
		const domainList = ref<any[]>([]);
		const error = ref<string | null>(null);
		const faceBookLogin = ref<number>(0);
		const helpText = ref<string>('');
		const helpTitle = ref<string>('');
		const idpList = ref<any[]>([]);
		const loaded = ref<boolean>(false);
		const loading = ref(true);
		const mainDomain = ref<string>(''); // Set dynamically later
		const mapsViewEnabled = ref<number>(0);
		const primaryDomain = ref<any>(null);

		const newFileData = reactive<{ group?: string }>({});
		const groupChildInfo = reactive<Record<string, boolean>>({});
		const progressWidth = computed(() => {
			return ((currentStep.value ) / (totalSteps - 1)) * 100; // Calculate percentage
		});
		onMounted(() => {
			fetchData();
		});
		const fetchData = async () => {
			if (props.vhostId && props.appId) {
				vhost.value = props.vhostId;
				appId.value = props.appId;

				await fetchAssets();
				await getApplicationInfo();
				await getChannelTree();
				await getGroupTree();
				await getTranslations();
			}
		};
		const normalizer = (node: Node): NormalizedNode => {
			return {
				id: node.id,
				label: node.name,
			};
		};
		const setChannel = (val: Val) => {
			saveTranslation('uploadPage', 'chan_Content', val.id);
		};

		// Method to add a group
		const addGroup = (val: Val) => {
			saveTranslation('uploadPage', 'grp_Primary', val.id);
		};
		const removeGroup = (index: Number) => {
			config.value.uploadPage.groupOptions.splice(index,1);
			saveTranslation('uploadPage', 'groupOptions', JSON.stringify(config.value.uploadPage.groupOptions)); 
		};

		const getQueryParamAsNumber = (param: LocationQueryValue | LocationQueryValue[] | undefined | null): number => {
			if (Array.isArray(param)) {
				return param.length > 0 ? Number(param[0]) : 0; // Use first value if it's an array
			}
			return param ? Number(param) : 0; // Convert string or return 0 if null or undefined
		};
		const handleGroupChange = (index:number, key: string, value: any) => {
			config.value.uploadPage.groupOptions[index][key]=value;
			saveTranslation('uploadPage', 'groupOptions', JSON.stringify(config.value.uploadPage.groupOptions));
			if(config.value.uploadPage.groupOptions[index].groupId>0) {
				let fieldIndex = mediaFields.value.findIndex(item => item.type === 'group' && item.related_id == config.value.uploadPage.groupOptions[index].groupId );
				Object.assign(uploadField, { field: 'group', type: 'Group', label: config.value.uploadPage.groupOptions[index].label, key: '', width: 1,required:0,helpText:'',related_id:config.value.uploadPage.groupOptions[index].groupId});
				if (fieldIndex == -1 ) {
					mediaFields.value.push({ ...uploadField });
				} else {
					mediaFields.value[fieldIndex]=uploadField;
				}
				saveTranslation('uploadPage', 'mediaFields', JSON.stringify(mediaFields.value));

				Object.assign(uploadField, { field: '', type: '', label: '', key: '', width: 1,required:0,helpText:'',related_id:0 });
			}
		};
		const handleChange = (category:string, key: string, value: any) => {
			const target = value.target as HTMLInputElement | null; // Type assertion
			if (target) { // Check if target is not null
				const value = String(target.value); // Convert value to string
				saveTranslation(category, key, value); // Pass the string value
				config.value[category][key]=value;
			} else {
				const newValue = value ? '1':'0';
				saveTranslation(category, key, newValue); // Pass the string newValue
				config.value[category][key]=newValue;
			}
		};
		// Log appId for debugging
		const addDomain = () => {
			additionalDomains.value.push(''); // Add an empty string or a default value
		};

		// Remove a domain by index
		const removeDomain = (index: number) => {
			additionalDomains.value.splice(index, 1); // Remove the domain at the specified index
		};
		// Function to set the header image
		const saveTranslation = (category: string, keyword: string, value: boolean | string) => {
			const stringValue = typeof value === 'boolean' ? (value ? '1' : '0') : value;

			return new Promise((resolve, reject) => {
				axios.post('/services/json', {
					method: 'i18n.updateString',
					appId: appId.value,
					language: 'en',
					category,
					keyword,
					string: stringValue 
				}).then(() => {
					resolve(true);
				}).catch(error => {
					reject(error);
				});
			});
		};
		const debouncedUpdate = useDebounce(saveTranslation, 500);


		// Define the updateStep method
		const updateStep = (index: number) => {
			currentStep.value = index;
		};
		const goToStep = (step: number) => {
			currentStep.value = step;
		};
		const addEmptyGroup = () => {
			const newGroup = { ...emptyGroup };
			config.value.uploadPage.groupOptions.push(newGroup);
		};
		const getTranslations = async () => {
			try {
				const response = await axios.post('/services/json', {
					method: 'i18n.getStrings',
					appId: appId.value,
					language: 'en',
				});

				config.value = response.data.result;
				profileFields.value = JSON.parse(config.value.registration.userFields);
				mediaFields.value = JSON.parse(config.value.uploadPage.mediaFields);
				if (typeof config.value.uploadPage.groupOptions =='undefined') {
					config.value.uploadPage.groupOptions=[];
				} else {
					config.value.uploadPage.groupOptions=JSON.parse(config.value.uploadPage.groupOptions);
				}
				loaded.value = true;
			} catch (error) {
				console.error('Error fetching translations:', error);
			}
		};
		const getApplicationDomains = async () => {
			try {
				const response = await axios.post('/services/json', {
					method: 'applications.getApplicationDomains',
					applicationID: appId.value,
				});

				additionalDomains.value = response.data.result;

				getIDPs();
				getDomains();

				additionalDomains.value.forEach((domain: any) => {
					if (domain.main_domain === 1 || additionalDomains.value.length === 1) {
						primaryDomain.value = domain;

						if (domain.facebook_app_id) {
							faceBookLogin.value = 1;
						}

						if (domain.googlemaps_api_key) {
							mapsViewEnabled.value = 1;
						}
					}
				});
			} catch (error) {
				console.error('Error fetching application domains:', error);
			}
		};
		const getApplicationInfo = async () => {
			try {
				const response = await axios.post('/services/json', {
					method: 'applications.getApplicationInfoById',
					appID: appId.value
				});

				if (response.data && response.data.result) {
					applicationInfo.value = response.data.result; // Set the application info
					mainDomain.value = applicationInfo.value.maindomain; // Set the main domain if it exists
					getApplicationDomains(); // Call further functions if needed
				}
			} catch (error) {
				console.error('Error fetching application info:', error);
			}
		};
		const setHelpInfo = (val: string) => {
			switch (val) {
				case 'loginUsername':
					helpTitle.value = 'Choose Email or Username for User Login';
					helpText.value = `
					<p><strong>Overview:</strong></p> 
					<p>The Uploader allows you, as a client, to decide whether your users will log in using either an <strong>email address</strong> or a <strong>username</strong>—but not both. This customization provides more control over how your users interact with your website during the login process.</p> 
					<h3>Key Differences:</h3> 
					<h4>Email Login:</h4> 
					<ul> 
					<li><strong>User familiarity:</strong> Most users are accustomed to using their email for logging into services, providing a familiar experience.</li> 
						<li><strong>Security:</strong> Email addresses are unique, helping avoid conflicts during user registration.</li> 
					<li><strong>Account recovery:</strong> Since emails are tied to communication, they simplify processes like password resets or account recovery.</li> 
					</ul> 
					<h4>Username Login:</h4> 
					<ul> 
					<li><strong>Personalization:</strong> Usernames allow users to express themselves with a personalized handle, creating a more customized experience.</li> 
					<li><strong>Anonymity:</strong> Username login can offer a layer of privacy, as users don’t need to reveal their email addresses for logging in.</li> 
						<li><strong>User engagement:</strong> Platforms that encourage community interaction (like forums or social apps) often benefit from username-based logins for building user identity.</li> 
							</ul> 
					<h3>How It Works:</h3> 
					<p><strong>Choose One:</strong> As a client, you select whether users can log in via <strong>email</strong> or <strong>username</strong> based on what best fits your platform's needs. Only one option will be available to the user.</p> 
					<p><strong>System Configuration:</strong> Based on your choice, the system will enforce either email or username requirements during registration and login.</p> 
					<p>This feature allows you to tailor the login experience to best match your platform's user base and overall goals.</p>`;
					break;

				case 'login':
					helpTitle.value = 'Default Prompt';
					helpText.value = `
					<p><strong>This setting determines what a user sees when they first visit the uploader:</strong></p> 
					<ul> 
					<li><strong>Login:</strong> The user will be directed to the login page, with an option to switch to the registration form if they don't have an account.</li> 
						<li><strong>Register:</strong> The user will be shown the registration page, with a link to switch to the login form if they already have an account.</li> 
							</ul> 
					<p>This allows you to set the default experience based on whether users are more likely to log in or create a new account.</p>`;
					break;

				case 'cname':
					helpTitle.value = "CNAME Information";
					helpText.value = `
					<h2>What is a CNAME Record?</h2> 
					<p>A <strong>CNAME (Canonical Name)</strong> record is a type of DNS record that maps an alias name to the true or canonical domain name. Instead of pointing directly to an IP address like an A record, the CNAME record points to another domain name. This is useful when you want multiple domain names to refer to the same website or service without needing to manage separate DNS records.</p>
					<p>For example, if you have a custom domain like <code>uploader.yourwebsite.com</code>, you would use a CNAME record to connect <code>uploader.yourwebsite.com</code> to the current uploader domain <code>${vhost.value}.uploader.newspark.ca</code>.</p>
					<h2>How to Configure a CNAME Record</h2> 
					<ol> 
					<li><strong>Log into Your Domain Provider</strong>: <p>Sign in to your domain registrar or DNS hosting provider (such as GoDaddy, Namecheap, or Cloudflare).</p></li>
					<li><strong>Access DNS Settings</strong>: <p>Navigate to the DNS management section. This is often called "DNS settings," "DNS management," or "Zone Editor."</p></li>
					<li><strong>Add a New CNAME Record</strong>: <p>Look for an option to add a new record, typically a button that says "Add" or "Create Record." Select <strong>CNAME</strong> as the record type.</p></li>
						<li><strong>Configure the CNAME Record</strong>: 
						<ul> 
					<li><strong>Name/Host/Label</strong>: Enter the alias or subdomain you want to use (e.g., <code>uploader</code>).</li>
					<li><strong>Value/Target/Points To</strong>: Enter the domain name you want it to point to <code>${vhost.value}.uploader.newspark.ca</code>.</li>
					<li><strong>TTL (Time to Live)</strong>: This is how long the DNS record is cached. If you’re unsure, you can leave the default setting.</li>
					</ul>
					</li>
					<li><strong>Save Your Changes</strong>: <p>After entering the details, save your new CNAME record. Changes might take up to 48 hours to propagate globally, but they often happen much sooner.</p></li>
					</ol>`;
					break;
			}
		};

		// Function to check if a file is an image
		const isImage = (filename: string): boolean => {
			const imageExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.svg'];
			return imageExtensions.some(ext => filename.endsWith(ext));
		};

		const fetchAssets = async () => {
			try {
				axios.post('/services/json',{
					'method':'vhost.getAssetList',
					'vhostID': vhost.value,
					'recursive':true,
					'path': '/',
					'flatten':true
				}).then(function (response) {
					assetList.value=response.data.result;
				});

			} catch(err) {
			}
		};
		const addSamlDomain = (hostName: string): void => {
			// Check if ssoDomains is not an array
			if (!Array.isArray(newFeaturesData.value.ssoDomains)) {
				console.log('Not Array');

				// Check if ssoDomains is undefined
				if (typeof newFeaturesData.value.ssoDomains === 'undefined') {
					console.log('Not defined');

					// If ssoDomains is defined in features, split it into an array
					if (typeof features.value.ssoDomains !== 'undefined') {
						console.log('is defined');
						newFeaturesData.value.ssoDomains = features.value.ssoDomains.split(/,/);
					} else {
						newFeaturesData.value.ssoDomains = [];
					}
				} else {
					newFeaturesData.value.ssoDomains = [];
				}
			}

			// Add the domain if it's not already in the array
			if (!newFeaturesData.value.ssoDomains.includes(saml.value.domain)) {
				newFeaturesData.value.ssoDomains.push(saml.value.domain);
			}
			console.log(newFeaturesData.value.ssoDomains);

			// Use arrow function to preserve `this` context
			new Promise<void>((resolve, reject) => {
				axios.post('/services/json', {
					method: 'vhost.addSamlDomain',
					vhostID: vhost.value,  // Assuming `vhost` is a global variable or defined elsewhere
					domain: saml.value.domain,
					entityid: saml.value.entity_id,
					emailattribute: saml.value.email_attribute,
					hostname: hostName
				})
					.then(() => {
						getDomains();
						getIDPs();
						saml.value = { domain: '', entity_id: '', email_attribute: '',newEntity:'' };  // Reset saml
						resolve();
					})
					.catch(error => {
						console.error(error);
						reject(error);
					});
			});
		};
		const delSamlDomain = (index: number): void => {
			// Use arrow function to preserve `this` context
			new Promise<void>((resolve, reject) => {
				axios.post('/services/json', {
					method: 'vhost.delSamlDomain',
					vhostID: vhost.value, // Assuming `vhost` is a global variable or defined elsewhere
					hostname: domainList.value[index].hostname,
					domain: domainList.value[index].domain
				})
					.then(() => {
						// Refresh the domain list after deletion
						getDomains();
						resolve();
					})
					.catch(error => {
						console.error(error);
						reject(error);
					});
			});
		};
		const getDomains = async () => {
			try {
				const response = await axios.post('/services/json', {
					method: 'vhost.getSamlDomains',
					hostname: mainDomain.value,
					vhostID: vhost.value,
				});

				domainList.value = response.data.result.data;
				console.log('Domains:', response.data.result.data);
			} catch (error) {
				console.error('Error fetching domains:', error);
			}
		};

		const getIDPs = async () => {
			try {
				const response = await axios.post('/services/json', {
					method: 'vhost.getIDPList',
					vhostID: vhost.value,
				});

				idpList.value = response.data.result;

				if (idpList.value.length === 0) {
					saml.value.newEntity = '';
				}

				console.log('IDP List:', response.data.result);
			} catch (error) {
				console.error('Error fetching IDPs:', error);
			}
		};

		const getGroupTree = async () => {
			try {
				const response = await axios.post('/services/json', {
					method: 'groups.getGroupTree',
					vhost: vhost.value,
					moderationStatus: 'all',
					removeEmptyChildNodes: 1
				});

				if (response.data.status === true) {
					groupTree.value.push({ id: 0, name: 'Select Group' });
					groupTree.value.push({ id: -1, name: 'Group(s) contributor belongs to' });
					groupTree.value = groupTree.value.concat(response.data.result);
				}
			} catch (error) {
				console.error('Error fetching group tree:', error);
			}
		};

		// Function to fetch channel tree
		const getChannelTree = async () => {
			try {
				const response = await axios.post('/services/json', {
					method: 'channels.getChannelTree',
					vhost: vhost.value,
					removeEmptyChildNodes: 1
				});

				if (response.data.status === true) {
					channelTree.value = response.data.result;
					channelTree.value.push({ id: 0, name: 'Top Level' });
				}
			} catch (error) {
				console.error('Error fetching channel tree:', error);
			}
		};

		// Capitalize function
		const capitalize = (val: string) => {
			return val.charAt(0).toUpperCase() + val.slice(1);
		};
		const saveOrder = () => {
			saveTranslation('registration', 'userFields', JSON.stringify(profileFields.value));
		};

		// Method to save media field order
		const saveMediaOrder = () => {
			saveTranslation('uploadPage', 'mediaFields', JSON.stringify(mediaFields.value));
		};

		const addProfileField = () => {
			profileFields.value.push({ ...registrationField });
			saveTranslation('registration', 'userFields', JSON.stringify(profileFields.value));
			Object.assign(registrationField, { field: '', type: '', label: '', key: '', width: 1,helpText:'',required:0 });
		};

		const removeProfileField = (index: number) => {
			profileFields.value.splice(index, 1);
			saveTranslation('registration', 'userFields', JSON.stringify(profileFields.value));
		};

		const addMediaField = () => {
			mediaFields.value.push({ ...uploadField });
			saveTranslation('uploadPage', 'mediaFields', JSON.stringify(mediaFields.value));
			Object.assign(uploadField, { field: '', type: '', label: '', key: '', width: 1,required:0,helpText:'',related_id:0 });
		};

		const removeMediaField = (index: number) => {
			mediaFields.value.splice(index, 1);
			saveTranslation('uploadPage', 'mediaFields', JSON.stringify(mediaFields.value));
		};

		const updateMediaField = <K extends keyof MediaField>(index: number, field: K, val: any) => {
			mediaFields.value[index][field] = val;
			saveTranslation('uploadPage', 'mediaFields', JSON.stringify(mediaFields.value));
		};

		const updateProfileField = <K extends keyof ProfileField>(index: number, field: K, val: any) => {
			profileFields.value[index][field] = val; // Correctly use profileFields.value
			saveTranslation('registration', 'userFields', JSON.stringify(profileFields.value));
		};


		return {
			addDomain,
			addMediaField,
			addProfileField,
			addSamlDomain,
			additionalDomains,
			appId,
			applicationInfo,
			assetList,
			capitalize,
			channelTree,
			config,
			currentStep,
			currentPage,
			data,
			debouncedUpdate,
			delSamlDomain,
			domainList,
			error,
			faceBookLogin,
			fieldTypes,
			getApplicationDomains,
			getChannelTree,
			getDomains,
			getGroupTree,
			getIDPs,
			getTranslations,
			goToStep,
			groupTree,
			handleChange,
			handleGroupChange,
			helpText,
			helpTitle,
			idpList,
			isImage,
			loaded,
			loading,
			mainDomain,
			mapsViewEnabled,
			mediaFields,
			predefinedMediaFields,
			predefinedProfileFields,
			predefinedWidths,
			primaryDomain,
			profileFields,
			setChannel,
			addGroup,
			removeGroup,
			addEmptyGroup,
			newFileData,
			groupChildInfo,
			progressWidth,
			removeDomain,
			removeMediaField,
			removeProfileField,
			saml,
			saveTranslation,
			setHelpInfo,
			step,
			normalizer,
			totalSteps,
			updateMediaField,
			updateProfileField,
			updateStep,
			vhost,
			saveMediaOrder,
			saveOrder,
			selectedProfileWidth,
			uploadField,
			registrationField,
		};
	},
});
</script>

<template>
	<div class="hidden space-y-6 p-4 pb-16 md:block">
		<div class="flex space-x-12">
			<div class="w-full">
				<div class="w-full">
					<div class="space-y-3">
						<div v-if="currentPage =='up-defaults'">
							<div class="flex w-full mt-4">
								<div class="basis-1/2">
									<Card>
									<CardHeader>
									<CardTitle>Branding</CardTitle>
									</CardHeader>
									<CardContent>
									<div class="flex justify-between w-full">
										<div>
											<h3>Logo</h3>
										</div>
										<div class="pl-3">
											<HoverCard>
											<HoverCardTrigger><QuestionMarkCircledIcon class="text-sky-500"/></HoverCardTrigger>
											<HoverCardContent>
											This logo will be used throughout the upload experience, in the header navigation and e-mails sent to the users. To add your logo to available options use <a :href="'/assets?vid=' + vhost" target="_new" class="text-sky-500"> Asset Manager</a>.
											</HoverCardContent>
											</HoverCard>
										</div>
									</div>


									<Select v-if="assetList.length>0" v-model="config.global.assets_headerImage"  @update:modelValue="saveTranslation('global', 'assets_headerImage', config.global.assets_headerImage)"> 
										<SelectTrigger> Select Logo</SelectTrigger>
									<SelectContent>
									<template  v-for="(file, index) in assetList" :key="index">
										<SelectItem :value="'https://assets.newspark.ca/' + file.key" v-if="isImage(file.key)">
									<img :src="'https://assets.newspark.ca/' + file.key"  class="border border-b p-1 max-w-[100px]" />
									</SelectItem>
									</template>
									</SelectContent>
									</Select>

									<div v-else>
										Please upload assets
									</div>
									<div class="flex justify-center align-center w-full p-3">
										<img v-if="!config.global.assets_headerImage" src="https://assets.newspark.ca/2/gfx/acme.png" class="img-fluid max-h-[100px]" />
										<img v-else :src="config.global.assets_headerImage" class="img-fluid max-h-[100px]" />
									</div>
									</CardContent>
									</Card>
							</div>
							<div class="basis-1/2 flex flex-col px-2">
								<Card>
								<CardHeader>
								<CardTitle>Other Settings </CardTitle>
								<CardDescription>
								Miscelaneous settings.
								</CardDescription>
								</CardHeader>
								<CardContent>
								<h2 class="text-lg">Domain Settings</h2>
								<div class="ml-4 small form-text text-slate-600 block">
									Advanced users can learn more about <a href="#" v-if="applicationInfo!=null" class="text-sky-500" @click.prevent="goToStep(7)">Single Sign On</a> and <a href="#" class="text-sky-500" data-toggle="modal" data-target="#helpModal" @click.prevent="setHelpInfo('cname')">CNAME records</a>.  <span v-if="applicationInfo!=null"> The CNAME must point to {{applicationInfo.vhost}}.uploader.newspark.ca.  </span>
								</div>
								<div >
									<Label for="mainDomain"> Primary Domain</Label>
									<Input type="text"  v-model="mainDomain" placeholder="example.newspark.ca" disabled/>
								</div>
								</CardContent>
								</Card>
								<Card class="mt-2">
								<CardHeader>
								<CardTitle>
								Additional Domains
								</CardTitle>
								</CardHeader>
								<CardContent>
								<p class="card-text text-sm text-muted-foreground">Need additional domains? We got you covered.</p>
								<div v-for="(domain, index) in additionalDomains" :key="index" class="flex w-full max-w-sm items-center gap-1.5 mt-3" >
									<Input type="text"  v-model="domain.domain" :placeholder="vhostId+'-' + (index + 1) + '.uploader.newspark.ca'"/>
									<Button variant="destructive"  @click="removeDomain(index)">
										<MinusCircleIcon class="h-6 w-6"/>
										&nbsp;&nbsp; 
										Remove
									</Button>
								</div>
								<Button class="mt-4" @click="addDomain"><PlusCircleIcon class="h-6 w-6"/>&nbsp;&nbsp; Add Domain</Button>
								</CardContent>
								</Card>
							</div>
						</div> 

					</div>
				</div>
				<div v-if="currentPage=='up-login'" class="w-full">
					<Tabs default-value="loginFeatures" class="w-full mt-4">
					<TabsList class="grid w-full grid-cols-2">
					<TabsTrigger value="loginFeatures">
					Features
					</TabsTrigger>
					<TabsTrigger value="logincopy">
					Copy
					</TabsTrigger>
					</TabsList>
					<TabsContent value="loginFeatures">
					<Card>
					<CardHeader>
					<CardTitle>
					Features
					</CardTitle>
					</CardHeader>
					<CardContent>
					<div class="flex  items-start space-x-10 ">
						<div>
							<div class="flex flex-col items-start  w-full pb-3 border-b">
								<div class="flex items-center">
									<Switch id="allow-registration" :checked="config.registration.allowRegistration==1"  @update:checked="(value) => handleChange('registration', 'allowRegistration', value)"/>
									<Label for="allow-registration" class="p-2">Allow Registration</Label>
								</div>
								<div class="ml-4 small form-text text-muted-foreground block">Allow users to sign up and log in.</div>
							</div>
							<div class="flex flex-col items-start  w-full pb-3 border-b">
								<div class="flex items-center">
									<Switch id="login-default" :checked="config.registration.loginDefault==1" true-value="1" false-value="0" @update:checked="(value) => handleChange('registration', 'loginDefault', value)" :disabled="config.registration.allowRegistration==0"/>
									<Label for="login-default" class="p-2">Login Tab as Default </Label>
								</div>
								<div class="ml-4 small form-text text-muted-foreground">Control whether the user sees the login or registration when arriving.</div>
							</div>
						</div>
						<div>
							<div class="flex flex-col items-start  w-full pb-3 border-b">

								<div class="flex items-center">
									<Switch id="login-default" :checked="config.registration.loginType==1" true-value="1" false-value="0" @update:checked="(value) => handleChange('registration', 'loginType', value)" :disabled="config.registration.allowRegistration==0"/>
									<Label for="login-default" class="p-2">Allow Usernames</Label>
								</div>
								<div class="ml-4 small form-text text-muted-foreground">If enabled usernames will be used to validate users, otherwise it will default to their e-mail.</div>
							</div>
							<div class="flex flex-col items-start  w-full pb-3 border-b">

								<div class="flex items-center">
									<Switch id="login-default" :checked="config.registration.anonymousUsers==1" true-value="1" false-value="0" @update:checked="(value) => handleChange('registration', 'anonymousUsers', value)" :disabled="config.registration.allowRegistration==0"/>
									<Label for="login-default" class="p-2">Allow Anonymous Login</Label>
								</div>
								<div class="ml-4 small form-text text-muted-foreground">Allow users bypass username, password requirements.</div>
							</div>
						</div>
					</div>

					</CardContent>
					</Card>
					</TabsContent>
					<TabsContent value="logincopy">
					<Card class="mt-2" >
					<CardHeader>
					<CardTitle> Copy </CardTitle>
					<CardDescription>This refers to the text or labels that appear on your form. This text is visible to users and helps guide them through completing the form. You can customize it to make instructions clearer, adjust labels for better context, or update the wording to suit your needs. </CardDescription>
					</CardHeader>
					<CardContent>

					<div >
						<Label for="loginLabel">Email/Username Label</Label>
						<Input type="text"  v-model="config.registration.loginLabel" @change="debouncedUpdate('registration','loginLabel',config.registration.loginLabel)" />
					</div>
					<div >
						<Label  for="passwordLabel">Password Label</Label>
						<Input type="text"  v-model="config.registration.passwordLabel" @change="debouncedUpdate('registration','passwordLabel',config.registration.passwordLabel)" />
					</div>
					<div >
						<Label  for="loginPlaceholder">Email/Username Place Holder Text</Label>
						<Input type="text"  v-model="config.registration.loginPlaceholder" @change="debouncedUpdate('registration','loginPlaceholder',config.registration.loginPlaceholder)" />
					</div>
					<div >
						<Label  for="passwordPlaceholder">Password Placeholder</Label>
						<Input type="text"  v-model="config.registration.passwordPlacholder" @change="debouncedUpdate('registration','passwordPlacholder',config.registration.passwordPlacholder)" />
					</div>
					<div >
						<Label  for="Register Text">Register Text</Label>
						<Input type="text"  v-model="config.registration.registerText" @change="debouncedUpdate('registration','registerText',config.registration.registerText)" />
					</div>
					<div >
						<Label   for="loginButton">Login Button Text</Label>
						<Input type="text"  v-model="config.registration.loginButton" @change="debouncedUpdate('registration','loginButton',config.registration.loginButton)" />
					</div>
					</CardContent>
					</Card>

					</TabsContent>
					</Tabs>
				</div>
				<div v-if="currentPage=='up-reg'">

					<Tabs default-value="registrationFields" class="w-full mt-4">
					<TabsList class="grid w-full grid-cols-2">
					<TabsTrigger value="registrationFields">
					Fields
					</TabsTrigger>
					<TabsTrigger value="regCopy">
					Copy
					</TabsTrigger>
					</TabsList>
					<TabsContent value="registrationFields">
					<Card>
					<CardHeader>
					<CardTitle>
					Registration Fields
					</CardTitle>
					<CardDescription>
					User Fields (Drag/Drop in desired order)
					</CardDescription>
					</CardHeader>
					<CardContent>
					<div class="grid grid-cols-12  border-b font-weight-bold p-2 mb-2">
						<div class="col-span-4">Field</div>
						<div class="col-span-2">Type</div>
						<div class="col-span-2">Full Width</div>
						<div class="col-span-2">Required</div>
						<div class="col-span-2">Action</div>
					</div>
					<draggable v-model="profileFields" class="list-group" :options="{group:'profileFields'}"  @change="saveOrder()">
					<div class="grid grid-cols-12  border-b p-2" v-for="(profField, index) in profileFields" :key="index">
						<div class="col-span-4">{{ profField.label }}</div>
						<div class="col-span-2">{{ profField.type }}</div>
						<div class="col-span-2">
							<Switch :checked="profField.width==1"  @update:checked="(value) => updateProfileField(index, 'width', value)"/>
						</div>
						<div class="col-span-2">
							<Switch :checked="profField.required==1"  @update:checked="(value) => updateProfileField(index, 'required', value)"/>
						</div>
						<div class="col-span-2">
							<button class="btn btn-danger btn-sm " @click="removeProfileField(index)">Remove</button>
						</div>
					</div>
					</draggable>
					<Popover>
					<PopoverTrigger>
					<Button class="mt-3">
						Add Field
					</Button>
					</PopoverTrigger>
					<PopoverContent class="w-[600px]">
					<div class="flex justify-content-between">
						<div>
						</div>
						<div>
							<PopoverClose>
							<span class="text-2xl">
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
									<path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
								</svg>

							</span>
							</PopoverClose>
						</div>
					</div>
					<div class="grid grid-cols-2 gap-4 mt-2 ">
						<div >
							<Label for="mediaField">Choose Predefined Field</Label>
							<select v-model="registrationField.field" class="form-control">
								<option disabled value="">Select a field</option>
								<option v-for="field in predefinedProfileFields" :key="field" :value="field">{{ capitalize(field) }}</option>
								<option value="meta">Custom</option>
							</select>
						</div>
						<div >
							<div  v-if="registrationField.field=='meta'">
								<Label for="customProfileField">Field Label</Label>
								<input type="text" v-model="registrationField.label" class="form-control" placeholder="Field label Eg. What is your favourite color?">
								<Label for="customProfileField">Store field as</Label>
								<input type="text" v-model="registrationField.key" class="form-control" placeholder="Field metadata name eg. favourite_color ">
							</div>
							<div v-else>
								<Label for="customProfileField">Customize the Label</Label>
								<input type="text" v-model="registrationField.label" class="form-control" placeholder="Field Label">
							</div>
						</div>
						<div class="col-span-2 mt-2">
							<Label for="customProfileField">Help Text</Label>
							<input type="text" v-model="registrationField.helpText" class="form-control" placeholder="Explain description to user">
						</div>

						<div >
							<Label for="mediaFieldType">Field Type</Label>
							<select v-model="registrationField.type" class="form-control">
								<option disabled value="">Select a type</option>
								<option v-for="type in fieldTypes" :key="type">{{ type }}</option>
							</select>
						</div>
						<div >
							<Label for="mediaWidth">Field Width</Label>
							<select v-model="registrationField.width" class="form-control">
								<option disabled value="">Select a width</option>
								<option v-for="(width,index) in predefinedWidths" :key="width" :value="index">{{ width }}</option>
							</select>
						</div>
						<div class="col-span-2">
							<Switch v-model="registrationField.required"/>
							<Label for="mediaFieldRequired">&nbsp;&nbsp; This field is required</Label>
						</div>
					</div>
					<PopoverClose>
					<Button @click.prevent="addProfileField()" class="mt-4" :disabled="registrationField.field=='' ">Add Field</Button>
					</PopoverClose>
					</PopoverContent>
					</Popover>
					</CardContent>
					</Card>
					</TabsContent>
					<TabsContent value="regCopy">

					<Card class="mt-4">
					<CardHeader>
					<CardTitle>Copy </CardTitle>
					<CardDescription>This refers to the text or labels that appear on your form. This text is visible to users and helps guide them through completing the form. You can customize it to make instructions clearer, adjust labels for better context, or update the wording to suit your needs. </CardDescription>
					</CardHeader>
					<CardContent>
					<div >
						<Label for="loginLabel">Register Button</Label>
						<Input type="text"  v-model="config.registration.registerButton" @change="debouncedUpdate('registration','registerButton',config.registration.registerButton)" />
					</div>
					<div >
						<Label for="loginLabel">Have an account link</Label>
						<Input type="text"  v-model="config.registration.alreadyRegistered" @change="debouncedUpdate('registration','alreadyRegistered',config.registration.alreadyRegistered)" />
					</div>
					<div >
						<Label for="loginLabel">Difficult password text.</Label>
						<Input type="text"  v-model="config.registration.passwordDifficulty" @change="debouncedUpdate('registration','passwordDifficulty',config.registration.passwordDifficulty)" />
					</div>

					</CardContent>
					</Card>
					</TabsContent>
					</Tabs>


				</div>
				<div v-if="currentPage=='up-form'">
					<Tabs default-value="uploadFields" class="w-full mt-4">
					<TabsList class="grid w-full grid-cols-2">
					<TabsTrigger value="uploadFields">
					Fields
					</TabsTrigger>
					<TabsTrigger value="uploadCopy">
					Copy
					</TabsTrigger>
					</TabsList>
					<TabsContent value="uploadFields">
					<Card >

					<CardHeader>
					<CardTitle>
					Upload Form 
					</CardTitle>
					<CardDescription>
					Media Fields (Drag/Drop in desired order)
					</CardDescription>
					</CardHeader>
					<CardContent>
					<div class="grid grid-cols-12  border-b font-weight-bold p-2 mb-2">
						<div class="col-span-4">Field</div>
						<div class="col-span-2">Type</div>
						<div class="col-span-2">Full Width</div>
						<div class="col-span-2">Required</div>
						<div class="col-span-2">Action</div>
					</div>
					<draggable v-model="mediaFields" class="list-group" :options="{group:'mediaFields'}"  @change="saveMediaOrder()">
					<div class="grid grid-cols-12  border-b p-2" v-for="(field, index) in mediaFields" :key="index">
						<div class="col-span-4">{{ field.label }}</div>
						<div class="col-span-2"> {{ field.type }}</div>
						<div class="col-span-2">
							<Switch :checked="field.width==1"  @update:checked="(value) => updateMediaField(index, 'width', value)"/>
						</div>
						<div class="col-span-2">
							<Switch :checked="field.required==1"  @update:checked="(value) => updateMediaField(index, 'required', value)"/>
						</div>
						<div class="col-span-2">
							<button class="btn btn-danger btn-sm " @click="removeMediaField(index)">Remove</button>
						</div>
					</div>
					</draggable>
					<Popover>
					<PopoverTrigger>
					<Button class="mt-3">
						Add Field
					</Button>
					</PopoverTrigger>
					<PopoverContent class="w-[600px]">
					<div class="flex justify-content-between">
						<div>
						</div>
						<div>
							<PopoverClose>
							<span class="text-4xl"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
									<path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
								</svg>
							</span>
							</PopoverClose>
						</div>
					</div>
					<div class="grid grid-cols-2 gap-4 mt-2 ">
						<div >
							<Label for="mediaField">Choose Predefined Field</Label>
							<select v-model="uploadField.field" class="form-control">
								<option disabled value="">Select a field</option>
								<option v-for="(helpText,field) in predefinedMediaFields" :key="field" :value="field">{{ capitalize(field) }} ({{helpText}})</option>
								<option value="meta">Custom</option>
							</select>
						</div>
						<div >
							<div  v-if="uploadField.field=='meta'">
								<Label for="customProfileField">Field Label</Label>
								<input type="text" v-model="uploadField.label" class="form-control" placeholder="Field label Eg. What is your favourite color?">
								<Label for="customProfileField">Store field as</Label>
								<input type="text" v-model="uploadField.key" class="form-control" placeholder="Field metadata name eg. favourite_color ">
							</div>
							<div v-else>
								<Label for="customProfileField">Customize the Label</Label>
								<Input type="text" v-model="uploadField.label"  placeholder="Field Label"/>
							</div>
						</div>
						<div class="col-span-2 mt-2">
							<Label for="customProfileField">Help Text</Label>
							<Input type="text" v-model="uploadField.helpText"  placeholder="Explain description to user"/>
						</div>

						<div >
							<Label for="mediaFieldType">Field Type</Label>
							<select v-model="uploadField.type" class="form-control">
								<option disabled value="">Select a type</option>
								<option v-for="type in fieldTypes" :key="type">{{ type }}</option>
							</select>
						</div>
						<div >
							<Label for="mediaWidth">Field Width</Label>
							<select v-model="uploadField.width" class="form-control">
								<option disabled value="">Select a width</option>
								<option v-for="(width,index) in predefinedWidths" :key="width" :value="index">{{ width }}</option>
							</select>
						</div>
						<div class="col-span-2">
							<Switch v-model="uploadField.required"/>
							<Label for="mediaFieldRequired">&nbsp;&nbsp; This field is required</Label>
						</div>
					</div>
					<PopoverClose>
					<Button @click.prevent="addMediaField()" class="mt-4" :disabled="uploadField.field=='' ">Add Field</Button>
					</PopoverClose>
					</PopoverContent>
					</Popover>
					</CardContent>
					</Card>
					</TabsContent>
					<TabsContent value="uploadCopy">
					<Card class="mt-4">
					<CardHeader>
					<CardTitle>Copy </CardTitle>
					<CardDescription>This refers to the text or labels that appear on your form. This text is visible to users and helps guide them through completing the form. You can customize it to make instructions clearer, adjust labels for better context, or update the wording to suit your needs. </CardDescription>
					</CardHeader>
					<CardContent>
					<div >
						<Label for="headerLabel">Header</Label>
						<Input type="text"  v-model="config.uploadPage.pageHeader" @change="debouncedUpdate('uploadPage','pageHeader',config.uploadPage.pageHeader)"  placeholder="Tell us about yoour asset"/>
					</div>
					<div >
						<Label for="headerHelpLabel">Header Help Text</Label>
						<Input type="text"  v-model="config.uploadPage.pageHelpText" @change="debouncedUpdate('uploadPage','pageHelpText',config.uploadPage.pageHelpText)"  placeholder=""/>
					</div>
					<div >
						<Label for="browseButton">Browse Button</Label>
						<Input type="text"  v-model="config.uploadPage.browseButton" @change="debouncedUpdate('uploadPage','browseButton',config.uploadPage.browseButton)"  placeholder="Browse"/>
					</div>
					<div >
						<Label for="dropFilesText">Drop Files</Label>
						<Input type="text"  v-model="config.uploadPage.dropFileText" @change="debouncedUpdate('uploadPage','dropFileText',config.uploadPage.dropFileText)"  placeholder="Drop Files Here"/>
					</div>
					<div >
						<Label for="selectFiles">Select Files</Label>
						<Input type="text"  v-model="config.uploadPage.selectFilesText" @change="debouncedUpdate('uploadPage','selectFilesText',config.uploadPage.selectFilesText)"  placeholder="Selet Files"/>
					</div>
					<div >
						<Label for="uploadButton">Upload Button</Label>
						<Input type="text"  v-model="config.uploadPage.uploadButton" @change="debouncedUpdate('uploadPage','uploadButton',config.uploadPage.uploadButton)"  placeholder="Start Upload"/>
					</div>
					<div >
						<Label for="selectFiles">Clear Uploads</Label>
						<Input type="text"  v-model="config.uploadPage.clearUploads" @change="debouncedUpdate('uploadPage','clearUploads',config.uploadPage.clearUploads)"  placeholder="Clear Uploads"/>
					</div>
					<div >
						<Label for="uploadButton">Uploading</Label>
						<Input type="text"  v-model="config.uploadPage.uploadingText" @change="debouncedUpdate('uploadPage','uploadingText',config.uploadPage.uploadingText)"  placeholder="Upload in progress"/>
					</div>
					<div >
						<Label for="uploadButton">Error</Label>
						<Input type="text"  v-model="config.uploadPage.errorText" @change="debouncedUpdate('uploadPage','errorText',config.uploadPage.errorText)"  placeholder="Error(s)"/>
					</div>
					<div >
						<Label for="uploadButton">File Name</Label>
						<Input type="text"  v-model="config.uploadPage.fileNameText" @change="debouncedUpdate('uploadPage','fileNameText',config.uploadPage.fileNameText)"  placeholder="Name"/>
					</div>
					<div >
						<Label for="uploadButton">Size</Label>
						<Input type="text"  v-model="config.uploadPage.sizeText" @change="debouncedUpdate('uploadPage','sizeText',config.uploadPage.sizeText)"  placeholder="Filesize"/>
					</div>
					<div >
						<Label for="uploadButton">Complete</Label>
						<Input type="text"  v-model="config.uploadPage.completeText" @change="debouncedUpdate('uploadPage','completeText',config.uploadPage.completeText)"  placeholder="Complete"/>
					</div>

					</CardContent>
					</Card>
					</TabsContent>
					</Tabs>


				</div>
				<div v-if="currentPage=='up-set'">
					<Card class="mt-4">
					<CardHeader>
					<CardTitle>
					File Settings
					</CardTitle>
					<CardDescription>
					Configure the types of files your users can submit, and set limits on the number of uploads. 
					These settings ensure that only the accepted file types are uploaded by your users.
					</CardDescription>
					</CardHeader>
					<CardContent>
					<div class="flex justify-content-between space-x-4">
						<div class="basis-1/2">
							<div class="flex flex-col items-start ">
								<div class="flex flex-col items-start  w-full pb-3 border-b">
									<div class="flex items-center">
										<Switch id="allow-mediaId" :checked="config.uploadPage.returnMediaId==1"  @update:checked="(value) => handleChange('uploadPage', 'returnMediaId', value)"/>
										<Label for="allow-mediaId" class="p-2">Return Media ID to User after Upload.</Label>
									</div>
									<div class="ml-4 small form-text text-muted-foreground block">When enabled, on upload completion the media ID will be returned to the user.</div>
								</div>
								<div class="flex flex-col items-start  w-full pb-3 border-b">
									<div class="flex items-center">
										<Switch id="allow-allFiles" :checked="config.uploadPage.cb_allowUniqueInformation==1"  @update:checked="(value) => handleChange('uploadPage', 'cb_allowUniqueInformation', value)"/>
										<Label for="allow-allFiles" class="p-2">Allow unique title & descriptions</Label>
									</div>
									<p class="text-xs "> This allows users to edit the title & description of individual files when uploading in bulk, otherwise all the files will have the same Title and Descriptiona.</p>
								</div>
								<div class="flex flex-col items-start  w-full pb-3 border-b">
									<div class="flex items-center">
										<Switch id="allow-allFiles" :checked="config.uploadPage.cb_acceptAll==1"  @update:checked="(value) => handleChange('uploadPage', 'cb_acceptAll', value)"/>
										<Label for="allow-allFiles" class="p-2">Accept All File Types</Label>
									</div>
									<p class="text-xs ">Enable this option to allow all types of files, or disable it to specify file types below.</p>
								</div>
								<div class="flex flex-col items-start  w-full pb-3 border-b">
									<div class="flex items-center">
										<Switch id="login-default" :checked="config.uploadPage.cb_acceptImages==1" true-value="1" false-value="0" @update:checked="(value) => handleChange('uploadPage', 'cb_acceptImages', value)" :disabled="config.uploadPage.cb_acceptAll==1"/>
										<Label for="login-default" class="p-2">Allow Images, Photos</Label>
									</div>
								</div>
								<div class="flex flex-col items-start  w-full pb-3 border-b">
									<div class="flex items-center">
										<Switch id="login-default" :checked="config.uploadPage.cb_acceptVideos==1" true-value="1" false-value="0" @update:checked="(value) => handleChange('uploadPage', 'cb_acceptVideos', value)" :disabled="config.uploadPage.cb_acceptAll==1"/>
										<Label for="login-default" class="p-2">Allow Videos</Label>
									</div>
								</div>
								<div class="flex flex-col items-start  w-full pb-3 border-b">
									<div class="flex items-center">
										<Switch id="login-default" :checked="config.uploadPage.cb_acceptAudio==1" true-value="1" false-value="0" @update:checked="(value) => handleChange('uploadPage', 'cb_acceptAudio', value)" :disabled="config.uploadPage.cb_acceptAll==1"/>
										<Label for="login-default" class="p-2">Allow Audio</Label>
									</div>
								</div>
								<div class="flex flex-col items-start  w-full pb-3 border-b">
									<div class="flex items-center">
										<Switch id="login-default" :checked="config.uploadPage.cb_acceptText==1" true-value="1" false-value="0" @update:checked="(value) => handleChange('uploadPage', 'cb_acceptText', value)" :disabled="config.uploadPage.cb_acceptAll==1"/>
										<Label for="login-default" class="p-2">Allow Text</Label>
									</div>
								</div>
							</div>
							<div class="mt-3"> 
								<div v-if="config.uploadPage.limit < 1" class="text-red-500">Please enter a valid upload limit.</div>

							</div>
							<div class=" text-left">
								<NumberField id="uploadLimit" :default-value="18" :min="0" v-model="config.uploadPage.limit" @change="saveTranslation('uploadPage', 'limit', config.uploadPage.limit)">
								<Label for="uploadLimit">Upload Limit</Label>
								<NumberFieldContent>
								<NumberFieldDecrement />
								<NumberFieldInput />
								<NumberFieldIncrement />
								</NumberFieldContent>
								</NumberField>
							</div>





						</div>
						<div class="basis-1/2">
							<div class=" border-b pb-2">
								<Label>Channel </Label>
								<Input type="text"  v-model="config.uploadPage.channelLabel" @change="debouncedUpdate('uploadPage','channelLabel',config.uploadPage.channelLabel)"  placeholder="Channel" v-if="config.uploadPage.cb_includeChildChannels==1"/>
								<treeselect :multiple="false" :options="channelTree" :flat="true" placeholder="Select Channel"  :normalizer="normalizer" @select="setChannel" class='mt-3 text-dark' v-model="config.uploadPage.chan_Content"  />
								<div class="flex items-center mt-2">
									<Switch :checked="config.uploadPage.cb_includeChildChannels==1"  @update:checked="(value) => handleChange('uploadPage','cb_includeChildChannels',value)"/>
									<Label class="p-2">Include Child Channels </Label>
								</div>
								<p class="text-xs"> Channels allow you to organize and categorize your media uploads for easier access and management. Think of channels as folders that store related content, such as project-specific media or department-specific files. Media can only exist in one channel.  </p>
							</div>
							<h3 class="text-2xl">Group Destination(s)</h3>
							<p class="text-xs text-muted-foreground">Groups help further organize your uploads by adding an extra layer of categorization. Media can belong to multiple groups, each of which can have its own permission settings. You can restrict content submissions so that users are only able to upload to the groups they are members of.</p>
							<div class="mt-3" v-for="(groupOptions,index) in config.uploadPage.groupOptions" :key="index">
								<Input type="text"  v-model="groupOptions.label" @change="handleGroupChange(index,'label',groupOptions.label)"  placeholder="Select Category"/>
								<treeselect  :multiple="false" :options="groupTree" :flat="true" placeholder="Select Group"  :normalizer="normalizer"    instance-id='primary' class='mt-3' v-model="groupOptions.groupId"/>
								<div class="flex items-center justify-between mt-2">
									<div>
										<Switch :checked="groupOptions.includeChildren==1"  @update:checked="(value) => handleGroupChange(index,'includeChildren',value  ? 1 : 0)" />
										<Label class="p-2">Include Child Groups</Label>
									</div>
									<div>
										<Button variant='destructive' @click.prevent="removeGroup(index)">Remove</Button>
									</div>
								</div>

							</div>
							<Button @click.prevent="addEmptyGroup">Add</Button>
						</div>
					</div>

					</CardContent>
					</Card>
				</div>
				<div v-if="currentPage=='up-feel'">
					<Card>
					<CardHeader>
					<CardTitle>Colors & Fonts </CardTitle>
					</CardHeader>
					<CardContent>
					<div class="flex justify-start">
						<div>
							<Switch :checked="config.design.cb_defaultDark==1"  @update:checked="(value) => handleChange('design','cb_defaultDark',value)"/>
							<Label class="p-2">Dark Theme as Defaut</Label>
						</div>
					</div>

					<Tabs default-value="default" class="w-full mt-4">
					<TabsList class="grid w-full grid-cols-2">
					<TabsTrigger value="default">
					Default
					</TabsTrigger>
					<TabsTrigger value="dark">
					Dark
					</TabsTrigger>
					</TabsList>
					<TabsContent value="default">
					<div class="grid grid-cols-4 gap-4">
						<div>
							<Card>
							<CardHeader> <CardTitle>Body</CardTitle></CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full">
									<div class="border border-2 rounded border-slate-900 flex-none">
										<ColorInput v-model="config.design.colour_body" @change="saveTranslation('design', 'colour_body', config.design.colour_body)" format="hex"/>
									</div>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<div class="border border-slate-900 flex-none">
										<ColorInput v-model="config.design.colour_font" @change="saveTranslation('design', 'colour_font', config.design.colour_font)" format="hex"/>
									</div>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Primary </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_background" class="border border-slate-800" @change="saveTranslation('design', 'colour_background', config.design.colour_background)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_foreground" class="border border-slate-800" @change="saveTranslation('design', 'colour_foreground', config.design.colour_foreground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Secondary </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_secondaryBackground" @change="saveTranslation('design', 'colour_secondaryBackground', config.design.colour_secondaryBackground)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_secondaryForeground" @change="saveTranslation('design', 'colour_secondaryForeground', config.design.colour_secondaryForeground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Accent </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_accentBackground" @change="saveTranslation('design', 'colour_accentBackground', config.design.colour_accentBackground)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_accentForeground" @change="saveTranslation('design', 'colour_accentForeground', config.design.colour_accentForeground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle>Warning</CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dangerBackground" @change="saveTranslation('design', 'colour_dangerBackground', config.design.colour_dangerBackground)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dangerForeground" @change="saveTranslation('design', 'colour_dangerForeground', config.design.colour_dangerForeground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>

						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Muted </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_mutedBackground" @change="saveTranslation('design', 'colour_mutedBackground', config.design.colour_mutedBackground)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_mutedForeground" @change="saveTranslation('design', 'colour_mutedForeground', config.design.colour_mutedForeground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Cards </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_cardBackground" @change="saveTranslation('design', 'colour_cardBackground', config.design.colour_cardBackground)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_cardForeground" @change="saveTranslation('design', 'colour_cardForeground', config.design.colour_cardForeground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Popover </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_popoverBackground" @change="saveTranslation('design', 'colour_popoverBackground', config.design.colour_popoverBackground)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_popoverForeground" @change="saveTranslation('design', 'colour_popoverForeground', config.design.colour_popoverForeground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Border </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_border" @change="saveTranslation('design', 'colour_border', config.design.colour_border)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Input Field </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_inputFieldBorder" @change="saveTranslation('design', 'colour_inputFieldBorder', config.design.colour_inputFieldBorder)" format="hex"/>
									<Label class="px-4">Border</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Ring </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_ringColour" @change="saveTranslation('design', 'colour_ringColour', config.design.colour_ringColour)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
					</div>
					</TabsContent>

					<TabsContent value="dark">
					<div class="grid grid-cols-4 gap-4">
						<div>
							<Card>
							<CardHeader> <CardTitle>Body</CardTitle></CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full">
									<div class="border border-2 rounded border-slate-900 flex-none">
										<ColorInput v-model="config.design.colour_dark_body" @change="saveTranslation('design', 'colour_dark_body', config.design.colour_dark_body)" format="hex"/>
									</div>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<div class="border border-slate-900 flex-none">
										<ColorInput v-model="config.design.colour_dark_font" @change="saveTranslation('design', 'colour_dark_font', config.design.colour_dark_font)" format="hex"/>
									</div>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Primary </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_background" class="border border-slate-800" @change="saveTranslation('design', 'colour_dark_background', config.design.colour_dark_background)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_foreground" class="border border-slate-800" @change="saveTranslation('design', 'colour_dark_foreground', config.design.colour_dark_foreground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Secondary </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_secondaryBackground" @change="saveTranslation('design', 'colour_dark_secondaryBackground', config.design.colour_dark_secondaryBackground)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_secondaryForeground" @change="saveTranslation('design', 'colour_dark_secondaryForeground', config.design.colour_dark_secondaryForeground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Accent </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_accentBackground" @change="saveTranslation('design', 'colour_dark_accentBackground', config.design.colour_dark_accentBackground)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_accentForeground" @change="saveTranslation('design', 'colour_dark_accentForeground', config.design.colour_dark_accentForeground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle>Warning</CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_dangerBackground" @change="saveTranslation('design', 'colour_dark_dangerBackground', config.design.colour_dark_dangerBackground)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_dangerForeground" @change="saveTranslation('design', 'colour_dark_dangerForeground', config.design.colour_dark_dangerForeground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>

						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Muted </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_mutedBackground" @change="saveTranslation('design', 'colour_dark_mutedBackground', config.design.colour_dark_mutedBackground)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_mutedForeground" @change="saveTranslation('design', 'colour_dark_mutedForeground', config.design.colour_dark_mutedForeground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Cards </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_cardBackground" @change="saveTranslation('design', 'colour_dark_cardBackground', config.design.colour_dark_cardBackground)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_cardForeground" @change="saveTranslation('design', 'colour_dark_cardForeground', config.design.colour_dark_cardForeground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Popover </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_popoverBackground" @change="saveTranslation('design', 'colour_dark_popoverBackground', config.design.colour_dark_popoverBackground)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_popoverForeground" @change="saveTranslation('design', 'colour_dark_popoverForeground', config.design.colour_dark_popoverForeground)" format="hex"/>
									<Label class="px-4">Foreground</Label>
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Border </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_border" @change="saveTranslation('design', 'colour_dark_border', config.design.colour_dark_border)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Input Field </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_inputFieldBorder" @change="saveTranslation('design', 'colour_dark_inputFieldBorder', config.design.colour_dark_inputFieldBorder)" format="hex"/>
									<Label class="px-4">Border</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
						<div>
							<Card>
							<CardHeader> <CardTitle> Ring </CardTitle> </CardHeader>
							<CardContent>
							<div class="flex flex-col justify-between mt-2">
								<div class="flex justify-start w-full mt-2">
									<ColorInput v-model="config.design.colour_dark_ringColour" @change="saveTranslation('design', 'colour_dark_ringColour', config.design.colour_dark_ringColour)" format="hex"/>
									<Label class="px-4">Background</Label>
								</div>
								<div class="flex justify-start w-full mt-2">
								</div>
							</div>
							</CardContent>
							</Card>
						</div>
					</div>
					</TabsContent>
					</Tabs>




					</CardContent>
					</Card>
					<Card class=" mt-3">
					<CardHeader>
					<CardTitle>Other</CardTitle>
					</CardHeader>
					<CardContent>
					<div class="flex justify-between">
						<div class="flex flex-col justify-start basis-1/3">
							<div class="flex justify-start ">
								<div>
									<Label class="p-2">Default Font</Label>
								</div>
								<div>
									<Select v-model="config.design.font_family"  @update:modelValue="saveTranslation('design', 'font_family', config.design.font_family)">
										<SelectTrigger>
										<SelectValue placeholder="Select default font" />
										</SelectTrigger>
										<SelectContent>
										<SelectItem value="Arial, sans-serif"> Arial </SelectItem>
										<SelectItem value="Helvetica Neue', sans-serif"> Helvetica </SelectItem>
										<SelectItem value="Verdana, sans-serif"> Verdana </SelectItem>
										<SelectItem value="Georgia, serif"> Georgia </SelectItem>
										<SelectItem value="Times New Roman, serif"> Times New Roman </SelectItem>
										<SelectItem value="Palatino, serif"> Palatino </SelectItem>
										</SelectContent>
									</Select>

								</div>
							</div>
							<div class="flex flex-col justify-start  w-full mt-3">
								<div class="flex">
									<Label for="allow-registration" class="p-2">Hide Header</Label>
									<Switch id="allow-registration" :checked="config.global.hideHeader==1"  @update:checked="(value) => handleChange('global', 'hideHeader', value)"/>
								</div>
								<div class="small form-text text-muted-foreground">Don't display the header.</div>
							</div>
							<div class="flex flex-col justify-start  w-full mt-3">
								<div class="flex ">
									<Label for="allow-registration" class="p-2">Custom CSS</Label>
									<Switch id="allow-registration" :checked="config.design.cb_customCSS==1"  @update:checked="(value) => handleChange('design', 'cb_customCSS', value)"/>
								</div>
								<div class="small form-text text-muted-foreground">Over ride settings not available in the wizard..</div>
							</div>
						</div>
						<div class="basis-2/3">
							<div class="form-group mt-3" v-if="config.design.cb_customCSS==1">
								<Label>Enter Custom CSS</Label>
								<div class="small form-text text-muted-foreground "></div>
								<textarea style="height:400px" class="form-control form-control-sm" v-model="config.design.css" @change="debouncedUpdate('design','css',config.design.css)" >{{ config.design.css }}</textarea>
							</div>
						</div>
					</div>


					</CardContent>
					</Card>

				</div>
				<div v-if="currentPage=='up-sso'">

					<div >
						<Label>SP Entity ID</Label>
						<Input v-if="applicationInfo.saml_entityid" type="text" :value="applicationInfo.saml_entityid" class="form-control " readonly/>
						<Input v-else type="text" :value="'uploader:sp:'+appId" class="form-control " readonly/>
					</div>
					<div class="form-group form-check">
						<Switch :checked="config.registration.ssoRegistration==1"  @update:checked="(value) => handleChange('registration','ssoRegistration',value)"/>

						<Label class="form-check-Label" for="User SSO Creation">Allow creation of users SSO.</Label>
					</div>



					The SP meta data is available here.
					<a v-if="applicationInfo.saml_entityid" :href="'https://'+mainDomain+'/ss/module.php/saml/sp/metadata.php/'+applicationInfo.saml_entityid">Download here</a>
					<a v-else :href="'https://'+mainDomain+'/ss/module.php/saml/sp/metadata.php/uploader:sp:'+appId">Download here</a>
					<table class="table table-striped">
						<thead><tr><th>E-Mail Domain</th><th>Identity Provider</th><th>Attribute</th><th>Action</th></tr></thead>
						<tbody>
							<template  v-for="(domainInfo,index) in domainList">
								<tr scope="row">
									<td>{{domainInfo.domain}}</td><td>{{domainInfo.entity_id}}</td><td>{{domainInfo.email_attribute}}</td>
									<td><a href=# @click.prevent="delSamlDomain(index)"> <i class="bi bi-x-circle-fill text-danger"></i></a></td>
								</tr>
							</template>
							<tr scope="row" v-if="typeof saml.entity_id !='undefined'">
								<td><Input type="text"  v-model="saml.domain" placeholder="Enter e-mail domain "/></td>
								<td><Select v-model="saml.entity_id">
										<SelectTrigger placeholder="Select the provider"/>
										<SelectContent>
										<SelectGroup>
										<SelectItem v-for="idpInfo in idpList" :value="idpInfo.entity_id">
										{{idpInfo.entity_id}}
										</SelectItem>
										</SelectGroup>
										</SelectContent>
									</Select>
								</td>
								<td><Input type="text"  v-model="saml.email_attribute" placeholder="Identifier field eg. email, emailAddress "/></td>
								<td><button type="button" class="btn btn-sm btn-primary" @click.prevent="addSamlDomain(domainList[0].domain)">Save</button></td>


							</tr>
						</tbody>
					</table>
					<Button @click.prevent="saml.entity_id=''">Add entry</Button>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>

